import { Navigate, Route, Routes } from 'react-router-dom';

import AdminAnalytics from '@/pages/admin/AdminAnalytics';
import AdminBilling from '@/pages/admin/AdminBilling';
import AdminDashboard from '@/pages/admin/AdminDashboard';
import AdminModeration from '@/pages/admin/AdminModeration';
import AdminUsers from '@/pages/admin/AdminUsers';
import DashboardsHub from '@/pages/DashboardsHub';
import HotesseDashboard from '@/pages/hotesse/HotesseDashboard';
import HotesseHistorique from '@/pages/hotesse/HotesseHistorique';
import HotesseProfil from '@/pages/hotesse/HotesseProfil';
import HotesseScanner from '@/pages/hotesse/HotesseScanner';
import PartenaireCampagnes from '@/pages/partenaire/PartenaireCampagnes';
import PartenaireDashboard from '@/pages/partenaire/PartenaireDashboard';
import PartenaireLeads from '@/pages/partenaire/PartenaireLeads';
import PartenaireNouvelle from '@/pages/partenaire/PartenaireNouvelle';
import PartenaireStats from '@/pages/partenaire/PartenaireStats';

function App() {
  return (
    <Routes>
      <Route path="/" element={<DashboardsHub />} />
      <Route path="/dashboards" element={<DashboardsHub />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/admin/utilisateurs" element={<AdminUsers />} />
      <Route path="/admin/moderation" element={<AdminModeration />} />
      <Route path="/admin/facturation" element={<AdminBilling />} />
      <Route path="/admin/analytics" element={<AdminAnalytics />} />
      <Route path="/app" element={<HotesseDashboard />} />
      <Route path="/app/scanner" element={<HotesseScanner />} />
      <Route path="/app/historique" element={<HotesseHistorique />} />
      <Route path="/app/profil" element={<HotesseProfil />} />
      <Route path="/partenaire" element={<PartenaireDashboard />} />
      <Route path="/partenaire/campagnes" element={<PartenaireCampagnes />} />
      <Route path="/partenaire/nouvelle" element={<PartenaireNouvelle />} />
      <Route path="/partenaire/stats" element={<PartenaireStats />} />
      <Route path="/partenaire/leads" element={<PartenaireLeads />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
